/* global messg */
import './styles.scss'

import I18n from 'lib/i18n'
import React, { useEffect } from 'react'
import { useValues, useActions } from 'kea'

import updateHeaderFavourites from 'lib/bridge/update-header-favourites'
import { clearFilterState } from '~/scenes/search/filters-page/utils.js'

import sceneLogic from '~/scenes/search/logic'

export default function FavouritesButton () {
  const { updateFilter } = useActions(sceneLogic)
  const { filter, favourites, isSmallScreen } = useValues(sceneLogic)

  useEffect(() => {
    updateHeaderFavourites(favourites.length)
  }, [favourites.length])

  return (
    <div
      className={`wish-list${filter.favourites ? ' back' : favourites.length > 0 ? ' active' : ''}`}
      onClick={() => {
        if (filter.favourites || favourites.length > 0) {
          updateFilter({
            ...clearFilterState({ filterType: null, isSmallScreen, allFilters: true }),
            favourites: !filter.favourites,
            page: 1
          })
        } else {
          messg.error(I18n.t('favourites.none_present'), 4000)
        }
      }}
    >
      {filter.favourites
        ? I18n.t('react.search.favourites.go_back')
        : I18n.t('react.search.favourites.in_list', { count: favourites.length })}
    </div>
  )
}
